import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { getDurationMessage, getPriceText } from 'utils';
import { useFormState } from 'react-final-form';
import { CountInput } from 'formComponents/CountInput';
import styled from '@emotion/styled';
import { ServiceInfo } from '../types';
import { InfoIcon } from './InfoIcon';

const CountInputStyled = styled(CountInput)`
  display: inline-block;
`;

export const InfoIconStyled = styled(InfoIcon)`
  display: inline;
  vertical-align: sub;
`;

interface Props {
  service: ServiceInfo;
  warning?: boolean;
  showCountInput?: boolean;
  showCount?: boolean;
}

export const InfoService: React.FC<Props> = ({
  service,
  warning,
  showCountInput = false,
  showCount = false,
}) => {
  const { id, name, duration, maxCount, showDuration, showPrice } = service;
  const {
    values: { favorIds, favorCounts },
  } = useFormState<{
    favorIds?: string[];
    favorCounts?: Record<string, number>;
  }>();

  const isSelected = !!favorIds?.includes(id);
  const isShowCountInput =
    isSelected && showCountInput && !!maxCount && maxCount > 1;
  const isShowCount = showCount && !!maxCount && maxCount > 1;

  return (
    <>
      <Text color="black" textStyle="body1" lineHeight="5" translate="no">
        {name}
      </Text>
      {showPrice ? (
        <Text
          as="span"
          mr={4}
          color="highlight"
          textStyle="body2"
          whiteSpace="nowrap"
        >
          {getPriceText(service)}
        </Text>
      ) : null}
      {showDuration !== false && (
        <Text
          as="span"
          mr={4}
          color="grayText"
          textStyle="body2"
          whiteSpace="nowrap"
        >
          {getDurationMessage(duration)}
        </Text>
      )}
      {isShowCountInput && (
        <CountInputStyled
          name={`favorCounts.${id}`}
          available={warning ? favorCounts?.[id] : maxCount}
        />
      )}
      {isShowCount && (
        <Text as="span" textStyle="body2" whiteSpace="nowrap">
          <Text as="span" color="highlight">
            кол-во:{' '}
          </Text>
          <Text as="span" color="grayText">
            {favorCounts?.[id] ?? 1}
          </Text>
        </Text>
      )}
      {warning && (
        <Box display={{ xs: 'flex' }} alignItems={{ xs: 'center' }}>
          <Text color="warning" textStyle="body1">
            Нельзя добавить больше. Подробнее в&nbsp;
            <InfoIconStyled warning={1} small={1} />
          </Text>
        </Box>
      )}
    </>
  );
};
